import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import { BeatLoader } from "react-spinners";

type IProps = {
	loading: boolean;
	btnText: string;
	loaderBtnText?: string;
	mt?: number;
};
const CommonLoaderFormBtn = ({
	loading,
	btnText,
	loaderBtnText,
	mt,
}: IProps) => {
	return (
		<>
			{!loading ? (
				<Button
					type='submit'
					fullWidth
					variant='contained'
					disableElevation
					sx={{
						mt: 3,
					}}
				>
					{btnText || ""}
				</Button>
			) : (
				<LoadingButton
					fullWidth
					// variant='contained'
					disabled
					sx={{
						mt: mt || 3,
						// background: "red",
					}}
				>
					{loaderBtnText || btnText}
					<span style={{ marginTop: "5px" }}>
						<BeatLoader size={6} />
					</span>
				</LoadingButton>
			)}
		</>
	);
};

export default CommonLoaderFormBtn;
